import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  StringInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredZip } from "~/utils/validations";

type Values = {
  zipCode: string;
};

const validationSchema = Yup.object({
  zipCode: requiredZip,
});

export const ZipPage: FC = () => {
  const { t } = useTranslation();
  const { zipCode } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    zipCode: zipCode || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.zipPage.question")} />

          <StringInput
            id="zipCode"
            maxLength={5}
            placeholder={t("onboarding.zipPage.placeholder")}
          />
        </QuestionContainer>

        <NextButton />
      </FormContainer>
    </QuestionPageContainer>
  );
};
